export const TEAM_ACTIVE_ORDER_STATUSES = [
  'received',
  'confirmed',
  'shipment_received',
  'shipment_delivered',
  'on_way_to_pickup_point',
  'at_pickup_point',
  'patient_pick_up',
  'on_way_to_delivery_point',
  'at_delivery_point',
  'waiting_for_return_pickup',
  'return_patient_pick_up',
  'on_way_to_return_delivery_point',
  'at_return_delivery_point',
  'patient_delivery',
  'patient_not_taken',
  'patient_left_at_destination',
]

export default {
  TEAM_ACTIVE_ORDER_STATUSES,
}
